var _line, _line2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 15,
    viewBox: "0 0 442 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7.36401,
    x2: 434,
    y2: 7.36401,
    stroke: "#C0C0C0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7.00024,
    x2: 434,
    y2: 7.00024,
    stroke: "#FF9900",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.36401,
    r: 7,
    fill: "#FF9900"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 221,
    cy: 7.36401,
    r: 7,
    fill: "#FF9900"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 435,
    cy: 7.36401,
    r: 7,
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage3);
export default __webpack_public_path__ + "static/media/stage3.494676dcf8694f899f372d51c2e9f08f.svg";
export { ForwardRef as ReactComponent };